import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './CreateShopSuccessModal.styles';
import useScreenSize from '@/hooks/useScreenSize';
import { Popup } from '@/components/UI/Popup/Popup';
import { BottomSheet } from '@/components/UI/BottomSheet/BottomSheet';

interface CreateShopSuccessModalProps {
  showModal: boolean;
  onClose: () => void;
}

export const CreateShopSuccessModal: React.FC<CreateShopSuccessModalProps> = ({
  showModal,
  onClose,
}) => {
  const { t } = useTranslation();
  const { isLarge } = useScreenSize();

  const modalContent = (
    <S.ModalContent>
      <S.SuccessIcon />
      <S.ModalTitle>{t('shop.create.success.title')}</S.ModalTitle>
      <S.ModalDescription>
        {t('shop.create.success.description')}
      </S.ModalDescription>
      <S.ModalButton onClick={onClose}>
        {t('shop.create.success.button')}
      </S.ModalButton>
    </S.ModalContent>
  );

  return (
    <>
      {isLarge ? (
        <Popup
          isOpen={showModal}
          close={onClose}
          customSize={{ width: 'auto', height: 'auto' }}
        >
          {modalContent}
        </Popup>
      ) : (
        <BottomSheet isOpen={showModal} close={onClose}>
          {modalContent}
        </BottomSheet>
      )}
    </>
  );
};
